// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"b84fb400","140":"9f465710","248":"352355dc","292":"3f418d94","476":"f9c99df3","560":"60cb2e1d","592":"d3ad333e","652":"b0de4a54","760":"02a480e7","764":"828e908c","776":"3c4d042e","796":"03901bf9","816":"07cd4310","896":"9fed316f","907":"9ccb6169","956":"245782e9"}[chunkId] + ".chunk.js";
};